import * as React from 'react';
import { Component, Fragment } from 'react';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';

const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface IFilterChipProps {
    removeFilter?: (filter: string, names: string[]) => void;
    filterLabel: string|undefined;
    filterFlag: string;
    filterNames: string[];
    filterComponent: React.ReactNode;
    showFilter: boolean;
}

export class FilterChip extends Component<IFilterChipProps> {
    constructor(props) {
        super(props);
    }

    public render() {
        const classes = styles;
        const showRemove = this.props.removeFilter !== null && this.props.removeFilter !== undefined ?
            <IconButton title="Remove" aria-label="Remove" onClick={this.handleDelete} sx={classes.button}><CancelIcon /></IconButton> :
            <Fragment />;

        const chip = this.props.showFilter ?
            <Grid>
                <Grid container sx={classes.root} justifyContent="space-between" alignItems="center">
                    <Grid sx={classes.text}>
                        <Typography variant="body1">{this.props.filterLabel}</Typography>
                    </Grid>
                    {this.props.filterComponent}
                    <Grid>
                        {showRemove}
                    </Grid>
                </Grid>
            </Grid>
            :
            <Fragment />;

        return (
            <Fragment>
                {chip}
            </Fragment>
        );
    }

    private handleDelete = () => {
        if (this.props.removeFilter !== null && this.props.removeFilter !== undefined) {
            this.props.removeFilter(this.props.filterFlag, this.props.filterNames);
        }
    }
}

export default (FilterChip);
